import { Helmet } from "react-helmet";
import { withRouter } from "../_shared/withRouter";
import { useTranslation } from "react-i18next";
import SidebarArrow from "../template/_common/sidebarArrow";
import Header from "../template/_common/header";
import { useEffect, useState } from "react";
import { globalAlert, globalLoader } from "../actions/commonActions";
import { logOut } from "../_shared/commonFunction";
import { adminOnlineStoreFetchApi, adminOnlineStoreToggleApi } from "./_actions";
import SidebarComponent from "../template/admin/sidebarComponent";
import { Col, Container, Form, InputGroup, Row, Tab, Table, Tabs, Button } from "react-bootstrap";
import PendingOrderTable from "../template/admin/order/pendingOrderTable";
import DispatchedOrderTable from "../template/admin/order/dispachedOrderTable";
import CancelledOrderTable from "../template/admin/order/cancelledOrderTable";
import ProductsTable from "../template/admin/order/products/productsTable";
import ZonesTable from "../template/admin/order/zones/zonesTable";
import ConfirmDeactivateModal from "../template/admin/order/ConfirmDeactivateModal";

const ManageOrders = (props) => {
    const { t } = useTranslation();
    const [navbarToggle, setNavbarToggle] = useState(false);
    const [allowView, setAllowView] = useState(true);
    const [zoneValue, setZoneValue] = useState("All");
    const [mainTab, setMainTab] = useState("orders");
    const [subTab, setSubTab] = useState("pending");
    const [isActive, setIsActive] = useState(false);
    const [products, setProducts] = useState([]);
    const [zones, setZones] = useState([]);
    const [orders, setOrders] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const filterOrders = (orderList) => {
        if (!searchTerm) return orderList || [];
        const term = searchTerm?.toLowerCase();
        return (orderList || [])?.filter(order => 
            (order?.userTransactionId?.toLowerCase().includes(term)) ||
            (order?.onlineStoreAddress?.phone?.toLowerCase().includes(term)) ||
            (order?.onlineStoreAddress?.postalCode?.toLowerCase().includes(term)) ||
            (order?.onlineStoreAddress?.street?.toLowerCase().includes(term)) ||
            (order?.onlineStoreAddress?.address?.toLowerCase().includes(term)) ||
            (order?.onlineStoreAddress?.city?.toLowerCase().includes(term)) ||
            (order?.product?.name?.toLowerCase().includes(term))
        );
    };

    const handleSidebar = (data) => {
        setNavbarToggle(data);
    };

    useEffect(() => {
        callBasicApi();
    }, [isActive]);

    const callBasicApi = async () => {
        try {
            globalLoader(true);
            const res = await adminOnlineStoreFetchApi();
            if (res?.data?.status === 200) {
              setIsActive(res?.data?.data?.isOnlineStoreEnabled || false);
              setProducts(res?.data?.data?.products || []);
              setZones(res?.data?.data?.zones || []);
              setOrders(res?.data?.data?.orders || []);
            } else {
                globalAlert("error", res?.data?.message);
            }
            globalLoader(false);
        } catch (error) {
            globalAlert("error", error?.response?.data?.message);
            if (error?.response?.data?.status === 401) {
                logOut(props?.history, "/admin/login");
            }
            globalLoader(false);
        }
    };

    const [showModal, setShowModal] = useState(false);

    const handleShowModel = () => {
        setShowModal(true);
    };

    const confirmDeactivate = async () => {
        setShowModal(false);
        try {
            globalLoader(true);
            const res = await adminOnlineStoreToggleApi(!isActive);
            if (res?.data?.status === 200) {
              setIsActive(!isActive);
            } else {
                globalAlert("error", res?.data?.message);
            }
            globalLoader(false);
        } catch (error) {
            globalAlert("error", error?.response?.data?.message);
            if (error?.response?.data?.status === 401) {
                logOut(props?.history, "/admin/login");
            }
            globalLoader(false);
        }
    };

    return (
        <>
            {showModal && <ConfirmDeactivateModal
                show={showModal}
                onClose={() => setShowModal(false)}
                onConfirm={confirmDeactivate}
                isActive={isActive}
            />}
            <Helmet>
                <title>{t("admin.pageTitle.manageOrders")} - eC-Card</title>
                <meta name="viewport" content="width=1200, initial-scale=1" />
            </Helmet>
            {allowView && (
                <div className="admin-portal">
                    <Header roleType="admin" />
                    <div className={`${navbarToggle ? "active" : ""} wrapper`}>
                        <SidebarComponent
                            navbarToggle={navbarToggle}
                            // active={props.match.path}
                            menu="manageVenue"
                            subMenu="manage-order"
                        />
                        <div className="main">
                            <div className="main-wrapper">
                                <div>
                                    <p className="admin-banner">{t("admin.orders.title")}</p>
                                </div>
                                <SidebarArrow handleSidebarToggle={handleSidebar} />

                                <Container fluid className="manage-orders-container">
                                    <Row className="justify-content-between align-items-center mb-3">
                                        <Col>
                                            <div className="d-flex align-items-center">
                                                <Button 
                                                    variant="link" 
                                                    className="p-2 mb-1"
                                                    onClick={callBasicApi}
                                                >
                                                    <i className="fas fa-sync" style={{ fontSize: '16px' }}></i>
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
  <Form.Check 
    type="switch" 
    id="active-switch"
    style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}
  >
    <Form.Check.Input
      checked={isActive}
      onChange={handleShowModel}
      style={{ marginTop: 0, cursor: 'pointer' }}
    />
    <Form.Check.Label style={{ marginBottom: 0, cursor: 'pointer', lineHeight: 1 }}>
      {t("admin.orders.active")}
    </Form.Check.Label>
  </Form.Check>
</Col>
                                    </Row>
                                    {isActive && (
                                        <>
                                            {/* Main Tab Buttons */}
                                            <div className="tab-header">
                                                {["orders", "products", "zones"].map((tab) => (
                                                    <div
                                                        key={tab}
                                                        className={`tab-btn ${mainTab === tab ? "active" : ""}`}
                                                        onClick={() => setMainTab(tab)}
                                                    >
                                                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                                                    </div>
                                                ))}
                                            </div>

                                            {mainTab === "orders" && (
                                                <>
                                                    <InputGroup className="mb-3" style={{ width: '40%' }}>
                                                        <Form.Control 
                                                            placeholder={t("admin.orders.searchPlaceholder")} 
                                                            className="search-input mr-3" 
                                                            value={searchTerm}
                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                        />
                                                        {searchTerm && (
                                                            <Button 
                                                                variant="outline-secondary" 
                                                                onClick={() => setSearchTerm('')}
                                                            >
                                                                <i className="fas fa-times"></i>
                                                            </Button>
                                                        )}
                                                    </InputGroup>

                                                    {/* Sub Tabs */}
                                                    <div className="sub-tab-header">
                                                        {["pending", "dispatched", "cancelled"].map((tab) => (
                                                            <div
                                                                key={tab}
                                                                className={`sub-tab ${subTab === tab ? "active" : ""}`}
                                                                onClick={() => setSubTab(tab)}
                                                            >
                                                                {tab.charAt(0).toUpperCase() + tab.slice(1)}
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {subTab === "pending" && (
                                                        <PendingOrderTable 
                                                            orders={filterOrders(orders?.pendingOrders)}
                                                            callBasicApi={callBasicApi} 
                                                            history={props?.history}
                                                        />
                                                    )}

                                                    {subTab === "dispatched" && (
                                                        <DispatchedOrderTable 
                                                            orders={filterOrders(orders?.dispatchedOrders)}
                                                            callBasicApi={callBasicApi} 
                                                            history={props?.history}
                                                        />
                                                    )}
                                                    {subTab === "cancelled" && (
                                                        <CancelledOrderTable 
                                                            orders={filterOrders(orders?.cancelledOrders)}
                                                            callBasicApi={callBasicApi} 
                                                            history={props?.history}
                                                        />
                                                    )}
                                                </>
                                            )}

                                            {mainTab === "products" && (
                                                <ProductsTable products={products} callBasicApi={callBasicApi} history={props?.history} />
                                            )}
                                            {mainTab === "zones" && (
                                                <ZonesTable callBasicApi={callBasicApi} history={props?.history} zones={zones}/>
                                            )}
                                        </>
                                    )}
                                </Container>
                                {/* <div className=" d-flex flex-wrap position-relative admin-controls">
                                        </div> */}
                                {/* </div>

                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
export default withRouter(ManageOrders);
